import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/pro-light-svg-icons/faAngleRight";
import Fab from "@material-ui/core/Fab";
import { Theme, withTheme, WithTheme } from "@material-ui/core/styles";
import React from "react";

const getColor = (enabled: boolean, theme: Theme) =>
  enabled ? theme.palette.common.black : theme.palette.grey[500];

const getIcon = (isFirst: boolean) => (isFirst ? faAngleLeft : faAngleRight);

export interface IStepButtonProps extends WithTheme {
  enabled: boolean;
  isFirst: boolean;
}

const StepButtonBase: React.FC<IStepButtonProps> = ({ enabled, isFirst, theme, ...props }) => (
  <Fab size="small" color="default" disabled={!enabled} rel="nofollow" {...props}>
    <FontAwesomeIcon icon={getIcon(isFirst)} color={getColor(enabled, theme)} size="2x" />
  </Fab>
);

const StepButton = withTheme()(StepButtonBase);

export { StepButton };
